import _createForOfIteratorHelper from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { STATUS_COMPRESSING, STATUS_UPLOADING, STATUS_DONE, STATUS_ERROR, compressFile } from './compressFile';
import logger from '../utils/logger';
var log = logger.createLogger('inference');

// -> [ {fileIndex, tables: [ {tableIndex, ...} ], ...}]
function validFileTables(_ref) {
  var files = _ref.files;
  if (!files || !files.length) {
    log.error({
      files: files
    });
    return [];
  }
  return files.map(function (_ref2, fileIndex) {
    var name = _ref2.name,
      status = _ref2.status,
      fileStats = _ref2.fileStats;
    var _ref6 = fileStats || {},
      tables_schemas = _ref6.tables_schemas;
    return {
      name: name,
      fileIndex: fileIndex,
      status: status,
      fileStats: fileStats,
      tables: tables_schemas ? tables_schemas.map(function (_ref3, tableIndex) {
        var name = _ref3.name;
        return {
          name: name,
          tableIndex: tableIndex
        };
      }) : []
    };
    //if ([STATUS_COMPRESSING, STATUS_COMPRESSED, STATUS_UPLOADING].includes(status)) {
  }).filter(function (_ref4) {
    var status = _ref4.status,
      fileStats = _ref4.fileStats,
      tables = _ref4.tables;
    if (status != STATUS_DONE || !fileStats || !tables || !tables.length) {
      //log.error({status, fileStats, tlen: tables ? tables.length : 0})
      return false;
    }
    var is_uploaded = fileStats.is_uploaded,
      is_valid = fileStats.is_valid,
      tables_schemas = fileStats.tables_schemas;
    if (!is_uploaded || !is_valid || !tables_schemas) {
      //log.error({is_uploaded, is_valid, tables_schemas});
      return false;
    }
    return true;
  });
}
export function inferEdgeFileTable(_ref5) {
  var files = _ref5.files,
    fileIndex = _ref5.fileIndex,
    tableIndex = _ref5.tableIndex;
  if (!files || !files.length || fileIndex != null && fileIndex != undefined && tableIndex != null && tableIndex != undefined) {
    log.error('Bail!');
    return {
      fileIndex: fileIndex,
      tableIndex: tableIndex
    };
  }
  var options = validFileTables({
    files: files
  });
  if (fileIndex != null && fileIndex != undefined) {
    log.error('Filter!');
    options = options.filter(function () {
      var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return o.fileIndex === fileIndex;
    });
  }

  //log.error({options});
  return options.length ? {
    fileIndex: options[0].fileIndex,
    tableIndex: options[0].tables[0].tableIndex
  } : {
    fileIndex: fileIndex,
    tableIndex: tableIndex
  };
}

// ?{dtypes: {str->str}} -> {direct: bool, entity_types: [str], opts: {?EDGES: {str -> [str]}}}
// try to do direct src->entity/dst, else do direct:false with whatever hits if any, or all
export function inferHyperedges(tableObj) {
  if (!tableObj || !tableObj.dtypes || !Object.keys(tableObj.dtypes).length) {
    return {};
  }
  var from = [/source|src|start|from/i, /origin|orig|begin|initial/i];
  var to = [/destination|dst/i, /end|final|target/i];
  var entity = [/id|name|title|tag|label|handle/i, /entity|host|hst|account|acct|tenant|device|dvc|domain|url|fqdn|ip|user|usr/i, /alert|signature|rule|event|evt|action/i];

  //Pandas/excel puts these in
  var exclusions = /Unnamed:/;
  var remainingKeys = Object.keys(tableObj.dtypes);
  var partitions = {}; // str -> [ str ]
  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      name = _Object$entries$_i[0],
      rgxs = _Object$entries$_i[1];
    var currentKeys = [];
    var _iterator = _createForOfIteratorHelper(rgxs),
      _step;
    try {
      var _loop2 = function _loop2() {
        var rgx = _step.value;
        remainingKeys = remainingKeys.filter(function (key) {
          if (key.match(rgx) && !key.match(exclusions)) {
            currentKeys.push(key);
            log.info({
              name: name,
              key: key,
              rgx: rgx,
              exclusions: exclusions
            }, 'hyperedge inference hit');
            return false;
          }
          return true;
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    partitions[name] = currentKeys;
  };
  for (var _i = 0, _Object$entries = Object.entries({
      from: from,
      to: to,
      entity: entity
    }); _i < _Object$entries.length; _i++) {
    _loop();
  }
  log.info({
    partitions: partitions
  }, 'hyperedge inference partitions');
  if (!partitions['from'].length || !partitions['to'].length) {
    var combined = [].concat(partitions['from'], partitions['to'], partitions['entity']);
    return {
      allToAll: true,
      direct: true,
      entity_types: combined.length > 1 ? combined : Object.keys(tableObj.dtypes),
      categories: {}
    };
  } else {
    var sources = partitions['from'];
    var destinations = partitions['to'].concat(partitions['entity']);
    var edges = {};
    var categories = {};
    var _iterator2 = _createForOfIteratorHelper(sources),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var src = _step2.value;
        edges[src] = destinations;
        categories["c".concat(Object.keys(categories).length)] = [src, destinations, false];
      }
      //log.error({'EDGES': edges, 'to': partitions['to'], 'entity': partitions['entity']})
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return {
      allToAll: false,
      direct: true,
      entity_types: sources.concat(destinations),
      categories: categories,
      opts: {
        'EDGES': edges
      }
    };
  }
}
function hasNodesFile(visualizationBindings) {
  return visualizationBindings.shaper.simple.nodes.enabled && visualizationBindings.shaper.simple.nodes.node !== null && visualizationBindings.shaper.simple.nodes.node !== undefined && visualizationBindings.shaper.simple.nodes.fileIndex !== null && visualizationBindings.shaper.simple.nodes.fileIndex !== undefined && visualizationBindings.shaper.simple.nodes.tableIndex !== null && visualizationBindings.shaper.simple.nodes.tableIndex !== undefined;
}
export function hasNodeAttributes(visualizationBindings) {
  if (Object.keys(visualizationBindings.remote.compute).length) {
    return true;
  }
  if (hasNodesFile(visualizationBindings)) {
    return true;
  }
  return false;
}
export function inferNodeAttributes(visualizationBindings) {
  var algAttributes = Object.keys(visualizationBindings.remote.compute);
  var nodeFileAttributes = hasNodesFile(visualizationBindings) ? visualizationBindings.shaper.simple.nodes.attributes : [];
  var hasNodes = hasNodesFile(visualizationBindings);
  var nodeBindings = hasNodes ? [visualizationBindings.shaper.simple.nodes.node] : visualizationBindings.shaper.simple.hyperedges ? ['nodeID'] : [];
  return algAttributes.concat(nodeFileAttributes).concat(nodeBindings);
}